import { useQuery } from '@tanstack/react-query'
import { userTaskHostService } from '../../../../services/users-tasks/users-tasks-hosts'
import { useGetDates } from '../../../date/use-get-dates'
import { useGetMyProfile } from '../../profile/use-get-my-profile'

export const USER_TASK_HOST_FIRST_QUERY_KEY = 'getUserTaskHostFirst'

export const useGetUserTaskHostFirst = (
  userTaskHostDefaultId: number,
  enabled = true,
) => {
  const { user } = useGetMyProfile()
  const { day } = useGetDates()

  const { data, isLoading, refetch } = useQuery({
    queryKey: [
      USER_TASK_HOST_FIRST_QUERY_KEY,
      { userTaskHostDefaultId, userId: user?.id, dateTask: day },
    ],
    enabled,
    queryFn: () => {
      return userTaskHostService.getFirst({
        userTaskHostDefaultId,
        userId: user?.id,
        dateTaskInitial: day,
        dateTaskFinal: day,
        typeFilterDateTask: 'equal',
      })
    },
  })

  return {
    userTaskHost: data?.data,
    isLoading: isLoading,
    refetch,
  }
}
